@import (reference) '../../constants/spacing.module.less';

.container {
  gap: 20px;
  width: 100%;
  height: 100%;
  flex-flow: row nowrap;
}

.left,
.right {
  width: 50%;
}

// modal styles
.body {
  min-height: 525px;
  height: 1px;
}

.picker-header-title {
  padding: 0 @space-16;
  h2 {
    font-size: 16px;
    font-weight: 500;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &.handle-padding {
    margin-bottom: -@space-8;
  }
}

.title {
  font-weight: 500;
  margin-bottom: @space-8;
}
